export const getType = v => (v === undefined ? 'undefined' : v === null ? 'null' : v.constructor.name.toLowerCase())

export const isUndefined = v => v === undefined
export const isNull = v => v === null
export const isNil = v => v === undefined || v === null

export const isString = v => typeof v === 'string'
export const isFunction = v => typeof v === 'function'

export const isArray = v => getType(v) === 'array'
